/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Rows_OkInputs */

const en_import_rows_ok = /** @type {(inputs: Import_Rows_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rows imported`)
};

/**
* | output |
* | --- |
* | "Rows imported" |
*
* @param {Import_Rows_OkInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const import_rows_ok = /** @type {((inputs?: Import_Rows_OkInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Rows_OkInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_import_rows_ok(inputs)
});